export const efectoresImportLogActions = {

    FETCH_EFECTORES_IMPORT_FAILED: 'FETCH_EFECTORES_IMPORT_FAILED',
    FETCH_EFECTORES_IMPORT_SUCCESS: 'FETCH_EFECTORES_IMPORT_SUCCESS',
    FETCH_EFECTORES_IMPORT_PENDING: 'FETCH_EFECTORES_IMPORT_PENDING',
    UPLOAD_EFECTORES: 'UPLOAD_EFECTORES',

    fetchEfectoresImportSuccess: (efectorListId, {data}) => ({
        type: efectoresImportLogActions.FETCH_EFECTORES_IMPORT_SUCCESS,
        payload: {
          efectorListId: efectorListId,
          data
        }
      }),
  
      fetchEfectoresImportFailed: error =>({
          type:efectoresImportLogActions.FETCH_EFECTORES_IMPORT_FAILED,
          payload: error
      }),
  
      fetchEfectoresImportPending: efectorListId =>({
          type:efectoresImportLogActions.FETCH_EFECTORES_IMPORT_PENDING,
          payload:{
            efectorListId
          }
      }),

    uploadEfectores: file => ({
        type: efectoresImportLogActions.UPLOAD_EFECTORES,
        payload: {
            file
        }
    })
}

export const efectoresImportLogRequestActions = {
    failed: efectoresImportLogActions.fetchEfectoresImportFailed,
    success: efectoresImportLogActions.fetchEfectoresImportSuccess,
    pending: efectoresImportLogActions.fetchEfectoresImportPending
};